<template lang="html">

  <div>
    <form @submit.prevent="submitForm">
      <input type="number" placeholder="search for ID" name="userid"/>
    </form>

    <p id="id"><span class="small">ID:</span><br>{{user.id}}</p>
    <p id="count">{{user.drinkedBeers.length}} / {{beers.length}}</p>

  </div>

</template>

<script>

export default {
  props: {
    user: Object,
    beers: Array,
  },
  methods: {
    submitForm: function(submitEvent) {
      this.$emit('update-user', submitEvent.target.elements.userid.value);
    }
  }
}
</script>

<style lang="css" scoped>

input{
  text-align: center;
  padding: 12px;
}

#id {
  font-size: 6em;
  font-weight: bold;
  margin: 10px;
  line-height: 0.7em;
}

.small{
  font-size: 0.3em;
  font-weight: normal;
  margin: 0;
}

#count {
  margin-top: 20px;
  padding: 20px;
  background-color: var(--primaryColor);
  display: inline-block;
  color: var(--secondaryColor);
  border-radius: 5px;
  font-size: 2em;
  font-weight: bold;
}

</style>
